<template>
    <div class="my-send-select-page layout-sub-page">
        <!-- 1. 标题部分 -->
        <title-bar 
            v-bind:className="'my-send-select-title-bar'"
            v-bind:titleData="titleData"
            v-bind:backFunc="clickBack">
        </title-bar>

        <div class="my-send-select-content">
            <!-- 2. 搜索框部分 -->
            <div class="my-send-select-search">
                <search-input 
                    v-bind:className="'send-select-search-input'"
                    v-bind:inputId="searchInputId"
                    v-bind:searchData="searchData"
                    v-bind:inputFunc="inputSearch">
                </search-input>
            </div>
            <!-- 3. 列表部分 -->
            <record-search-list 
                v-if="searchResultList.length > 0"
                :resultList="searchResultList">
            </record-search-list>
            <div v-else class="my-send-select-list">
                <group-list :showEdit="false"></group-list>
            </div>
        </div>

        <!-- 4. 分享按钮 -->
        <div class="my-send-select-button" @click="clickShare">{{selectedGroupDataList.length == 0 && choosedMultipleItemList.length == 0 ? '请选择要分享的八字' : ('共享('+(selectedGroupDataList.length+choosedMultipleItemList.length)+')条')}}</div>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import SearchInput from '../../components/SearchInput.vue'
import GroupList from '../../layouts/group/GroupList.vue'
import RecordSearchList from '../../layouts/record/RecordSearchList.vue'
import { MIX } from '../../modules/utils';
export default {
    name: 'MySendSelect',
    components: { TitleBar, SearchInput, GroupList, RecordSearchList },
    computed: {
        selectedGroupDataList(){
            return this.$store.state.group.selectedGroupDataList;
        },
        searchData() {
            return this.$store.state.search.searchData;
        },
        searchResultList() {
            return this.$store.state.search.searchResultList;
        },
        choosedMultipleItemList() {
            return this.$store.state.chooserecord.choosedMultipleItemList;
        }
    },
    data(){
        return {
            titleData: {
                'titleText': '选择共享记录', 
                'hideButton': true, 
                'showCancel': false
            },
            searchInputId: 'sendSearchInput',
            searchText: '',
        }
    },
    mounted: function() {
        setTimeout(() => {
            this.initDom();
            MIX.trackPageViewed('SelectShareBzPage');
        }, 20);
    },
    created: function() {
        // 默认拉取分组数据
        this.$store.dispatch('group/initGroupList');
        var checkedGroup = this.$store.state.group.checkedGroup;
        if(!checkedGroup) {
            this.$store.dispatch('group/initGroupDefaultData');
        }
    },
    methods:{
        initDom() {
            let titleBarDom = document.getElementsByClassName('my-send-select-title-bar')[0],
                searchDom = document.getElementsByClassName('my-send-select-search')[0],
                listDom = document.getElementsByClassName('my-send-select-list')[0],
                bottomDom = document.getElementsByClassName('my-send-select-button')[0];
            if(titleBarDom && searchDom && bottomDom) {
                if(listDom) {
                    listDom.style.height = (innerHeight-titleBarDom.clientHeight-searchDom.clientHeight-bottomDom.clientHeight)+'px';
                }
            }
        },
        clickBack() {
            this.$store.dispatch('group/resetChooseGroupData');
            this.$store.dispatch('group/resetSelectedGroupListData');
            this.$store.dispatch('chooserecord/resetData');
            this.$router.replace('/my');
        },
        inputSearch(word) {
            console.log('selectedGroupDataList----', this.selectedGroupDataList)
            this.$store.state.search.searchData.searchText = word;
            if(word != ''){
                this.$store.dispatch('search/confirmSearchInput', word);
            }else{
                this.$store.state.search.searchResultList = [];
            }
        },
        clickShare() {
            let arr1 = this.selectedGroupDataList.map(el => el[0]);
            let arr2 = this.choosedMultipleItemList.map(el => el.id);
            let idArr = arr1.concat(arr2);
            if(idArr.length == 0) {
                return;
            }
            console.log('clickShare----', this.selectedGroupDataList, this.choosedMultipleItemList, idArr)
            let userVip = this.$store.state.userData.vip;
            if((userVip == 0 && idArr.length >= 32) || (userVip == 10 && idArr.length >= 64)) {
                let tText = userVip == 0 ? '非会员每次最多只能分享32个八字数据，你可以升级成会员以便享用更多的会员特权。' : '月会员每次最多只能分享64个八字数据，你可以升级成年会员以便享用更多的会员特权。';
                this.$toast({
                    message: tText,
                    className: 'van-toast--width-80',
                });
                this.$store.dispatch('user/showMyVipPop', {vip: userVip, frompage: 'share'});
                setTimeout(() => {
                    this.$bus.emit('initMyVipPage');
                }, 20);
                return;
            }

            this.$store.dispatch('record/sendShareCodeInfo', {
                idStr: idArr.join(','),
                sucCb: ()=> {
                    this.$router.replace('/my/sendbzcode');
                },
                failCb: ()=> {
                    this.$toast("分享八字失败");
                }
            })
        }
    }
}
</script>
